import { logger } from "@hopper-b2b/datadog";

export const openExternalUrl = (url: string) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    // NU-18 diagnostic: log external URL navigation (airline website)
    logger()?.info?.("NU-18 diag: openExternalUrl called", {
      targetDomain: new URL(url).hostname,
      currentPath: window.location.pathname,
      timestamp: Date.now(),
    });
    window.open(url, "_blank", "noopener,noreferrer")?.focus();
  }
};

// NuCloseButton to use: window.NuCloseButton.postMessage("") (closes webview)
export const closeNubankWebview = () => {
  if (!window.NuCloseButton || !window.NuCloseButton.postMessage) {
    console.warn("Nubank Handoff - NuCloseButton is not defined");
    return;
  }

  console.debug("Nubank Handoff - NuCloseButton");
  window.NuCloseButton.postMessage?.("");
};

// NuCopyText to use: window.NuCopyText.postMessage("text to be copied")
export const copyTextFromWebview = (text: string) => {
  if (!window.NuCopyText || !window.NuCopyText.postMessage) {
    console.warn("Nubank Handoff - NuCopyText is not defined");
    return;
  }

  console.debug("Nubank Handoff - NuCopyText", { text });
  window.NuCopyText.postMessage?.(text);
};

// NuOpenHelp to use: window.NuOpenHelp.postMessage("")  (opens faq on the app side)
export const openNubankHelp = () => {
  if (!window.NuOpenHelp || !window.NuOpenHelp.postMessage) {
    console.warn("Nubank Handoff - NuOpenHelp is not defined");
    return;
  }

  console.debug("Nubank Handoff - NuOpenHelp");
  window.NuOpenHelp.postMessage?.("");
};

// NuOpenTermsAndConditions to use: window.NuOpenTermsAndConditions.postMessage("")
export const openNubankTermsAndConditions = () => {
  if (
    !window.NuOpenTermsAndConditions ||
    !window.NuOpenTermsAndConditions.postMessage
  ) {
    console.warn("Nubank Handoff - NuOpenTermsAndConditions is not defined");
    return;
  }

  console.debug("Nubank Handoff - NuOpenTermsAndConditions");
  window.NuOpenTermsAndConditions.postMessage?.("");
};

// NuOpenDeeplink to use: window.NuOpenDeeplink.postMessage("message to display")
export const openNubankDeeplink = ({
  deeplink,
  params,
  pushMethod,
}: {
  deeplink: string;
  params?: Record<string, string | undefined> & {
    providerId?: string;
  };
  pushMethod?: "push-replacement";
}) => {
  if (!window.NuOpenDeeplink || !window.NuOpenDeeplink.postMessage) {
    console.warn("Nubank Handoff - NuOpenDeeplink is not defined");
    return false;
  }

  const { providerId, ...payloadParams } = params ?? {};
  if (providerId) {
    payloadParams["provider-id"] = providerId;
  }

  console.debug("Nubank Handoff - NuOpenDeeplink", {
    deeplink,
    params,
    pushMethod,
  });
  window.NuOpenDeeplink.postMessage(
    JSON.stringify({
      deeplink,
      params: payloadParams,
      ...(pushMethod ? { "push-method": pushMethod } : {}),
    })
  );
  return true;
};

export const goToNativeMyTripsFromCheckout = () =>
  openNubankDeeplink({
    deeplink: "nuviagens-mytrips",
    pushMethod: "push-replacement",
  });

export const openNubankChat = (
  msg = "Olá, gostaria de ajuda com Nu Viagens"
) => {
  openNubankDeeplink({
    deeplink: "chat",
    params: { msg },
  });
};

export const openNubankWallet = () => {
  openNubankDeeplink({
    deeplink: "cashback-feed",
    params: {
      // provider-id is fixed for UV customers https://hopchat.slack.com/archives/C0906FTEL0Y/p1754419193434329?thread_ts=1754419064.702839&cid=C0906FTEL0Y
      // <Slack-Context: #travel-ota-nubank-hopper from @thau on 2025-08-05> `Deeplink to open Cashback Hub history`
      //  :thread:
      // </Slack-Context>
      providerId: "df7064b0-55e1-4f98-9d37-303aad32404d",
      currency: "POINTS",
    },
  });
};
